import { render, staticRenderFns } from "./MenuTopGerente.vue?vue&type=template&id=0a111a0f&scoped=true&"
import script from "./MenuTopGerente.vue?vue&type=script&lang=js&"
export * from "./MenuTopGerente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a111a0f",
  null
  
)

export default component.exports